import { TreeSelectProps } from "@/shared/form/tree-select";
import { CompanyStructureSelectGetChildrenQuery } from "gql/graphql";

type Input =
  CompanyStructureSelectGetChildrenQuery["getAllCompanyHierarchyElements"][number];
export type Node = NonNullable<TreeSelectProps["treeData"]>[number];

export function toTree<T extends Input>(
  elements: T[],
  disabledTypeNames?: string[],
  rootId?: string,
) {
  const roots: T[] = [];
  const map: Record<string, T[]> = {};

  elements.forEach((elem) => {
    if (elem.hierarchy.parent?.id !== undefined) {
      map[elem.hierarchy.parent.id] = map[elem.hierarchy.parent.id] ?? [];
      map[elem.hierarchy.parent.id].push(elem);
    }

    if (rootId === undefined) {
      if (elem.hierarchy.parent?.id === undefined) {
        roots.push(elem);
      }
    } else if (elem.id === rootId) {
      roots.push(elem);
    }
  });

  function traverse(list: T[]): Node[] {
    const toDataNode = (item: T): Node => {
      const disabled =
        disabledTypeNames?.includes(item.__typename ?? "") ?? false;
      return {
        value: item.id,
        key: item.id,
        label: item.name.value,
        isLeaf: !map[item.id]?.length,
        children: map[item.id] && traverse(map[item.id]),
        __typename: item?.__typename,
        disabled,
      };
    };

    return list.map(toDataNode);
  }

  const treeData = traverse(roots);

  return treeData;
}
